import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { screenTitle } from 'utils/UrlListener';
import getCanonicalUrl from 'utils/canonicalUrl';
import { PLATFORMS } from '~/constants';
import { useLang } from '~/stores/i18n';

import availableLanguages from '../../resources/languages.json';
import IncludeOnPlatforms from '../hoc/IncludeOnPlatforms';

function DefaultHead() {
  const location = useLocation();
  const path = location.pathname.split('/');
  if (path.length > 1 && availableLanguages.indexOf(path[1]) > -1) {
    path.splice(1, 1);
  }
  const noindex =
    ENVIRONMENT !== 'production' ||
    path.includes('l') || // no index on all /l/ pages
    path.includes('s'); // no index on all /s/ pages

  const langCode = useLang();
  const title = screenTitle();

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="canonical" href={getCanonicalUrl(location.pathname)} />
      {availableLanguages.map((locale) => {
        const url = `${URL_HOST}${
          locale === 'en' ? '' : '/' + locale
        }${path.join('/')}`;
        return (
          <link key={locale} rel="alternate" href={url} hrefLang={locale} />
        );
      })}
      <html lang={langCode} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
    </Helmet>
  );
}

export default IncludeOnPlatforms([PLATFORMS.WEB])(DefaultHead);
